<lib-row-with-two-columns
  [breakpoint]="breakpointService.isTabletViewObservable"
  [revertOrderOnBreakpoint]="true"
  [column1FxLayoutAlign]="'start start'"
  [column2FxLayoutAlign]="'start start'"
  [fxLayoutGap]="'20px'"
>
  <div col-1 class="full-width">
    <lib-carousel
      *ngIf="images?.length"
      [autoplay]="true"
      [interval]="2000"
      [loop]="true"
      [hideArrows]="true"
      [hideIndicators]="true"
      [useKeyboard]="false"
      [useMouseWheel]="false"
      [maintainAspectRatio]="true"
      [orientation]="'LEFT_TO_RIGHT'"
    >
      <lib-carousel-slide *ngFor="let image of images; let i = index">
        <div class="teaser-image-wrapper">
          <img
            [alt]="salonName + '-' + i"
            [src]="image"
            (click)="displayImageInFullsize(i)"
          />
        </div>
      </lib-carousel-slide>
    </lib-carousel>
  </div>

  <div col-2 class="full-width">
    <lib-spacer></lib-spacer>
    <h1>{{ salonName }}</h1>
    <div>{{ salonAddress }}</div>

    <div *ngIf="averageReview" fxLayout="row" fxLayoutAlign="start center">
      <a
        *ngIf="linkToGoogleMapReviewsPage; else ratingStarTemplate"
        [href]="linkToGoogleMapReviewsPage"
        target="_blank"
      >
        <ng-container [ngTemplateOutlet]="ratingStarTemplate"></ng-container>
      </a>
      <ng-template #ratingStarTemplate>
        <app-rating-star-icon
          [rating]="averageReview"
          [totalReview]="totalReviews"
        ></app-rating-star-icon>
      </ng-template>
    </div>

    <ng-container *ngIf="googleMapsEmbedLink">
      <lib-spacer></lib-spacer>

      <button
        mat-flat-button
        color="primary"
        class="full-width"
        (click)="openGoogleMapEmbedIframeDialog()"
      >
        {{ 'salon-details-header.buttons.visit-virtually' | translate }}
      </button>
    </ng-container>

    <ng-container *ngIf="!hideShareButton">
      <lib-spacer></lib-spacer>

      <button
        mat-stroked-button
        color="primary"
        class="full-width"
        [disabled]="isCopiedLink"
        (click)="copyLinkToClipboard()"
      >
        {{
          (isCopiedLink
            ? 'salon-details-header.buttons.link-copied'
            : 'salon-details-header.buttons.share'
          ) | translate
        }}
      </button>
    </ng-container>

    <lib-spacer></lib-spacer>
  </div>
</lib-row-with-two-columns>
